import { Fragment } from 'react/jsx-runtime'
import {
	DiffSection,
	DiffSectionWrapper,
	FieldsDiffsSeparator
} from '@/features/ops-vetting/components/ops-vetting-merch-diffs'
import type { ServiceDiffsMap } from '../types'

interface ServiceVettingMerchCopyDiffsProps {
	serviceDiffsMap: ServiceDiffsMap
}
export const ServiceVettingMerchCopyDiffs = ({
	serviceDiffsMap
}: ServiceVettingMerchCopyDiffsProps) => {
	return (
		<DiffSectionWrapper>
			<DiffSection
				hasDiff={serviceDiffsMap.service_title.hasDiff}
				size={serviceDiffsMap.service_title.fieldSize}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={serviceDiffsMap.service_description.hasDiff}
				hasUpperDiff={serviceDiffsMap.service_title.hasDiff}
			/>
			<DiffSection
				hasDiff={serviceDiffsMap.service_description.hasDiff}
				size={serviceDiffsMap.service_description.fieldSize}
			/>
			<FieldsDiffsSeparator fieldType='sub-section' />
			{serviceDiffsMap.offerings.map((offering, index) => {
				const isLastItem =
					index === serviceDiffsMap.offerings.length - 1
				return (
					<Fragment
						key={`offering-${offering[0].fieldSize}-${offering[1].fieldSize}`}
					>
						<DiffSection
							hasDiff={offering[0].hasDiff}
							size={offering[0].fieldSize}
						/>
						<FieldsDiffsSeparator
							fieldType='consecutive-sm'
							hasLowerDiff={offering[1].hasDiff}
							hasUpperDiff={offering[0].hasDiff}
						/>
						<DiffSection
							hasDiff={offering[1].hasDiff}
							size={offering[1].fieldSize}
						/>
						{!isLastItem && (
							<FieldsDiffsSeparator fieldType='sub-section' />
						)}
					</Fragment>
				)
			})}

			<FieldsDiffsSeparator fieldType='section' />

			<DiffSection
				hasDiff={serviceDiffsMap.host_experience_title.hasDiff}
				size={serviceDiffsMap.host_experience_title.fieldSize}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					serviceDiffsMap.host_experience_description.hasDiff
				}
				hasUpperDiff={serviceDiffsMap.host_experience_title.hasDiff}
			/>
			<DiffSection
				hasDiff={serviceDiffsMap.host_experience_description.hasDiff}
				size={serviceDiffsMap.host_experience_description.fieldSize}
			/>

			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					serviceDiffsMap.host_career_highlight_title.hasDiff
				}
				hasUpperDiff={
					serviceDiffsMap.host_experience_description.hasDiff
				}
			/>
			<DiffSection
				hasDiff={serviceDiffsMap.host_career_highlight_title.hasDiff}
				size={serviceDiffsMap.host_career_highlight_title.fieldSize}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					serviceDiffsMap.host_career_highlight_description.hasDiff
				}
				hasUpperDiff={
					serviceDiffsMap.host_career_highlight_title.hasDiff
				}
			/>
			<DiffSection
				hasDiff={
					serviceDiffsMap.host_career_highlight_description.hasDiff
				}
				size={
					serviceDiffsMap.host_career_highlight_description.fieldSize
				}
			/>

			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={serviceDiffsMap.host_education_title.hasDiff}
				hasUpperDiff={
					serviceDiffsMap.host_career_highlight_description.hasDiff
				}
			/>
			<DiffSection
				hasDiff={serviceDiffsMap.host_education_title.hasDiff}
				size={serviceDiffsMap.host_education_title.fieldSize}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					serviceDiffsMap.host_education_description.hasDiff
				}
				hasUpperDiff={serviceDiffsMap.host_education_title.hasDiff}
			/>
			<DiffSection
				hasDiff={serviceDiffsMap.host_education_description.hasDiff}
				size={serviceDiffsMap.host_education_description.fieldSize}
			/>
		</DiffSectionWrapper>
	)
}
ServiceVettingMerchCopyDiffs.displayName = 'ServiceVettingMerchCopyDiffs'
